import {
  mdiAccountPlusOutline,
  mdiApi,
  mdiBookshelf,
  mdiCodeBraces,
  mdiBugOutline,
  mdiClipboardListOutline,
  mdiCloudOutline,
  mdiDatabaseOutline,
  mdiDatabasePlusOutline,
  mdiFileCheckOutline,
  mdiFileDocumentMultipleOutline,
  mdiFlaskOutline,
  mdiGraphOutline,
  mdiMessageProcessingOutline,
  mdiMonitorDashboard,
  mdiPackageVariantClosed,
  mdiPlayCircleOutline,
  mdiPowerPlugOutline,
  mdiServerOutline,
  mdiShieldOutline,
  mdiShieldSearch,
  mdiTestTube,
  mdiTextBoxOutline,
  mdiTools,
  mdiViewDashboardOutline,
} from '@mdi/js';

export type NavigationPath =
  | '/services/overview'
  | '/services/descriptions'
  | '/services/data'
  | '/services/ports'
  | '/services/dependencies'
  | '/services/graphql'
  | '/services/messages'
  | '/services/validation'
  | '/deployment/services'
  | '/deployment/trial'
  | '/tests/e2e/cases'
  | '/tests/e2e/plans'
  | '/tests/e2e/start'
  | '/tests/templates'
  | '/tests/onpremise'
  | '/security/cves'
  | '/system/repros'
  | '/devtools';

type NavigationItem = { label: string; icon: string; platformOnly?: boolean } & ({ path: NavigationPath } | { externalUrl: string });

export interface NavigationSection {
  id: string;
  label: string;
  icon: string;
  items: readonly NavigationItem[];
}

export const devToolsNavigationItem = { label: 'Puffin Dev Tools', icon: mdiCodeBraces, path: '/devtools' } satisfies NavigationItem;

export const navigationSections: readonly NavigationSection[] = [
  {
    id: 'services',
    label: 'Service Registry',
    icon: mdiBookshelf,
    items: [
      { label: 'Overview', icon: mdiViewDashboardOutline, path: '/services/overview' },
      { label: 'Descriptions', icon: mdiTextBoxOutline, path: '/services/descriptions' },
      { label: 'Processed & Stored Data', icon: mdiDatabaseOutline, path: '/services/data' },
      { label: 'Used Ports', icon: mdiPowerPlugOutline, path: '/services/ports' },
      { label: 'Dependencies', icon: mdiGraphOutline, path: '/services/dependencies' },
      { label: 'GraphQL Contracts', icon: mdiApi, path: '/services/graphql' },
      { label: 'Messaging Contracts', icon: mdiMessageProcessingOutline, path: '/services/messages' },
      { label: 'Validate Service Spec', icon: mdiFileCheckOutline, path: '/services/validation' },
    ],
  },
  {
    id: 'deployment',
    label: 'Deployment',
    icon: mdiCloudOutline,
    items: [
      { label: 'Service Dashboard', icon: mdiMonitorDashboard, path: '/deployment/services' },
      { label: 'Trial Demo Data', icon: mdiDatabasePlusOutline, path: '/deployment/trial' },
    ],
  },
  {
    id: 'testing',
    label: 'Testing',
    icon: mdiFlaskOutline,
    items: [
      { label: 'E2E Test Cases', icon: mdiTestTube, path: '/tests/e2e/cases' },
      { label: 'E2E Test Plans', icon: mdiClipboardListOutline, path: '/tests/e2e/plans' },
      { label: 'Start E2E Tests', icon: mdiPlayCircleOutline, path: '/tests/e2e/start' },
      { label: 'Test Templates', icon: mdiFileDocumentMultipleOutline, path: '/tests/templates' },
      { label: 'Onpremise Machines', icon: mdiServerOutline, path: '/tests/onpremise' },
      { label: 'Create Trial', icon: mdiAccountPlusOutline, externalUrl: 'https://website-gateway.meisterplan.io/trial-register' },
    ],
  },
  {
    id: 'security',
    label: 'Security',
    icon: mdiShieldOutline,
    items: [{ label: 'CVE Scan Results', icon: mdiShieldSearch, path: '/security/cves' }],
  },
  {
    id: 'self-service',
    label: 'Self Service',
    icon: mdiTools,
    items: [
      { label: 'Repro Systems', icon: mdiPackageVariantClosed, path: '/system/repros' },
      {
        label: 'Create Issue',
        icon: mdiBugOutline,
        externalUrl: 'https://jirajellyfish.meisterplan.in/',
        platformOnly: true,
      },
    ],
  },
];
